import UrlResolver from 'ha/helpers/UrlResolver';
import { ISODate } from '@ha/date';

import { Language, Locale } from '@ha/intl';

export interface Translations {
  [key: string]: string;
}

export interface IntlConfig {
  lang: Language;
  baseDomain: string;
  messages: Translations;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TranslateFunc = (key: string, ...args: any[]) => string;

export type FormatDateFunc = (format: string, isoDate: ISODate) => string;

export type IntlNumberFormatOptions = NonNullable<
  Parameters<typeof Intl.NumberFormat>[1]
>;

export type IntlCurrencyFormatOptions = IntlNumberFormatOptions & {
  inCents?: boolean;
  withCurrency?: boolean;
};

export type FormatNumberFunc = (
  value: number,
  options?: IntlNumberFormatOptions,
) => string;

export type FormatCurrencyFunc = (
  value: number,
  currency: string,
  options?: IntlCurrencyFormatOptions,
) => string;

export type FormatUnitFunc = (
  value: number,
  unit: string,
  options?: IntlNumberFormatOptions,
) => string;

export type ToLocalizedStringFunc = (isoDate: string) => string;

export interface IntlObject {
  lang: Language;
  locale: Locale;
  messages: Translations;
  urlResolver: UrlResolver;
  T: TranslateFunc;
  formatDate: FormatDateFunc;
  fromNow: FormatDateFunc;
  toLocalizedString: ToLocalizedStringFunc;
  formatNumber: FormatNumberFunc;
  formatCurrency: FormatCurrencyFunc;
  formatUnit: FormatUnitFunc;
}

export interface IntlProps {
  intl: IntlObject;
}
export { Language, Locale };
